import React, { createContext, useContext, useState } from 'react';

interface DashboardContextType {
  refreshDashboard: () => void;
  setRefreshFunction: (fn: () => void) => void;
  isRefreshing: boolean;
  setIsRefreshing: (refreshing: boolean) => void;
}

const DashboardContext = createContext<DashboardContextType | null>(null);

export function DashboardProvider({ children }: { children: React.ReactNode }) {
  const [refreshFunction, setRefreshFunction] = useState<(() => void) | null>(null);
  const [isRefreshing, setIsRefreshing] = useState(false);

  const refreshDashboard = () => {
    if (refreshFunction && !isRefreshing) {
      setIsRefreshing(true);
      refreshFunction();
    }
  };

  const setRefreshFunctionHandler = (fn: () => void) => {
    setRefreshFunction(() => fn);
  };

  return (
    <DashboardContext.Provider value={{
      refreshDashboard,
      setRefreshFunction: setRefreshFunctionHandler,
      isRefreshing,
      setIsRefreshing
    }}>
      {children}
    </DashboardContext.Provider>
  );
}

export function useDashboard() {
  const context = useContext(DashboardContext);
  if (!context) {
    throw new Error('useDashboard must be used within a DashboardProvider');
  }
  return context;
}